import { Search, X } from 'lucide-react';
import Select from 'react-select';
import React from 'react'

interface UserFilterProps {
  textValue: string
  onClearSearch: () => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (selectedOption: any) => void;
}


const CampaignFilter: React.FC<UserFilterProps> = ({ onSearch, onStatusChange, textValue, onClearSearch }) => {

  const options = [
    { value: 'Hidden', label: 'All Status' },
    { value: 'Sent', label: 'Sent' },
    { value: 'Draft', label: 'Draft' },
  ];
  return (
    <div className="!py-2 dark:border-zink-500">
      <form action="#!">
        <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
          <div className="relative xl:col-span-3">
            <input
              type="text"
              className="ltr:pl-8 ltr:pr-8 rtl:pr-8 rtl:pl-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Search for Campaign Name or Subject"
              autoComplete="off"
              onChange={onSearch}
              value={textValue}
            />
            <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
            <X
              className="inline-block size-4 absolute ltr:right-2.5 rtl:left-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600 cursor-pointer hover:text-slate-700 dark:hover:text-zink-100"
              onClick={onClearSearch}
            />
          </div>
          <div className="xl:col-span-2">
            <Select
              className="border-slate-200 z-50 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              options={options}
              isSearchable={false}
              defaultValue={options[0]}
              onChange={onStatusChange}
              id="choices-single-default"
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default CampaignFilter